import axios from 'axios'
import utils from './utils'

const https = require('https')
const agent = new https.Agent({  
	rejectUnauthorized: false
})
const baseURL = 'https://intranet.acttiv.es/api-pias/v1'
const login = {
	login: 'Descubre',
	pass: 'LSqfnVdFuiA'
}

const acttivServices = {
  getToken: async function () {			
		const token = await axios.put(`${baseURL}/session/login`, login, {
			httpsAgent: agent
		})
		.then(response => {
        axios.delete(`${baseURL}/session/logout`, {
          headers: {
            'Content-type': 'application/json; charset=UTF-8', // Indicates the content
            'Authorization': `Bearer ${response.data.token}`
          },				
          httpsAgent: agent,			
        })
			return response.data.token
		})
		.catch((err) => {
		  console.log(err)
		  return null
		})
	},
  getPias: async function (hotelID, date ) {
    console.log('jhm', this.getToken())
    return
    /*return
    await axios.put(`${baseURL}/session/login`, login, {
			httpsAgent: agent
		})
		.then(response => {
			const token = response.data.token
      console.log(token)
      let mainError = null
      try {
        const pia = await axios.get(`${baseURL}/pias/pia?idHotel=${hotelID}&fecha=${date}`, {
          headers: {
            'Content-type': 'application/json; charset=UTF-8', // Indicates the content
            'Authorization': `Bearer ${token}`
          },				
          httpsAgent: agent,			
        })
        
        console.log('pias', pia)
      
        await axios.delete(`${baseURL}/session/logout`, {
          headers: {
            'Content-type': 'application/json; charset=UTF-8', // Indicates the content
            'Authorization': `Bearer ${token}`
          },				
          httpsAgent: agent,			
        })

        return pia ? pia.data : null
      }
      catch (error) { 
        console.log('jhm1',error.message)
        axios.delete(`${baseURL}/session/logout`, {
          headers: {
            'Content-type': 'application/json; charset=UTF-8', // Indicates the content
            'Authorization': `Bearer ${token}`
          },				
          httpsAgent: agent,			
        })
        return { error: true, value: error.message }
      }

    })*/
	},
}

export default acttivServices
